import React from 'react'
import { useDisplayTheme, useSysTheme } from 'hooks/useUiState'
// @ts-ignore
import { Tooltip, QuestionMarkOutlined } from '@netbasequid/core'
import styled, { css } from 'styled-components'
import openHelpPage from 'utils/helpLinkUtil'

import { ExplanationData } from '../../../types'
import LinkButton from '../../../../../../share/LinkButton'

interface ExplanationAnchorProps {
  styles?: ReturnType<typeof css>
}
export const ExplanationAnchor = styled.div<ExplanationAnchorProps>`
  ${({ styles }) => styles}

  display: none;
  // need this to be hoverable
  z-index: 1;
`

export type ExplanationProps = {
  iconSize: number
} & ExplanationData &
  ExplanationAnchorProps

export const Explanation = ({
  styles: iconAnchorStyles,
  tooltipContent: content,
  link,
  iconSize
}: ExplanationProps) => {
  const theme = useDisplayTheme()
  const sys = useSysTheme()

  return (
    <ExplanationAnchor styles={iconAnchorStyles}>
      <Tooltip mode={theme} content={content}>
        <LinkButton onClick={() => openHelpPage(link)}>
          <QuestionMarkOutlined color={sys.text.placeholder} fontSize={iconSize} />
        </LinkButton>
      </Tooltip>
    </ExplanationAnchor>
  )
}
